import { Form as DigitalizationFormComponent } from "./Digitalization.js";

export const DigitalizationForm = DigitalizationFormComponent;
